export const formatClassName = (names: unknown[]): string =>
  names.filter(Boolean).join(" ");
